import axiosInstance from './axiosInstance';

export const getDashboardOverview = () =>
  axiosInstance.get('/api/dashboard/overview', { withCredentials: true });

const noRequestBodyConfig = {
  withCredentials: true,
  // This route is URL-driven; do not inherit JSON Content-Type for an empty body.
  headers: { 'Content-Type': null },
};

export const markDashboardNotificationRead = (id) =>
  axiosInstance.patch(
    `/api/dashboard/notifications/${encodeURIComponent(id)}`,
    undefined,
    noRequestBodyConfig
  );
